import styled from 'styled-components';

export default styled.span`
  font-size: 14px;
  color: ${(props) => props.theme['color.text.body']};
  white-space: nowrap;
  flex: 1 1;
`;
